var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearningCardBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2813_30560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9825 2.60122C12.6102 2.23036 13.3898 2.23036 14.0175 2.60123L22.8089 7.79618C23.5256 8.21967 23.905 9.04279 23.7615 9.86278L21.8622 20.7162C21.7741 21.2196 21.4968 21.6701 21.087 21.9753L14.1948 27.1099C13.4858 27.6381 12.5142 27.6381 11.8052 27.1099L4.913 21.9753C4.50324 21.6701 4.22586 21.2196 4.13778 20.7162L2.23848 9.86278C2.09499 9.0428 2.47441 8.21967 3.19108 7.79618L11.9825 2.60122Z",
    fill: "#FFCF61"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3176 6.93525L14.5262 1.7403C13.5848 1.18401 12.4152 1.184 11.4738 1.7403L2.68235 6.93525C1.60734 7.57049 1.03821 8.80518 1.25345 10.0352L3.15275 20.8886C3.28487 21.6436 3.70094 22.3194 4.31558 22.7773L11.2077 27.9118C12.2712 28.7041 13.7288 28.7041 14.7923 27.9118L21.6844 22.7773C22.2991 22.3194 22.7151 21.6436 22.8473 20.8886L24.7466 10.0352C24.9618 8.80518 24.3927 7.57049 23.3176 6.93525Z",
    stroke: "#ECB22E",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2813_30560",
    x: -0.791504,
    y: -3.67688,
    width: 26.583,
    height: 33.1829,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2813_30560"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningCardBadge);
export default __webpack_public_path__ + "static/media/LearningCardBadge.fe08c5d5c6b798677921e9a45ba3f0f6.svg";
export { ForwardRef as ReactComponent };